import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import OrgChartComponent from '../../../../components/Chart/OrgChart/OrgChartComponent';
import Loader from '../../../../components/Loader/Loader';
import PageContent from '../../../../components/PageContent/PageContent';
import orgHierarchyandProcessFlowAPI from '../../../../services/modules/Configurator/orgHierarchyandProcessFlowAPI';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {ChartType} from '../constants/Constants';

const OrgHierarchy: React.FC = () => {
  const [mainData, setMainData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState('');
  const [searchParam, setSearchParams] = useSearchParams();
  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  useEffect(() => {
    if (selectedYear) {
      setIsLoading(true);
      orgHierarchyandProcessFlowAPI(selectedYear, ChartType.orgHierarchy)
        .then((res) => {
          setMainData(res ?? []);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedYear]);

  return (
    <PageContent>
      {isLoading ? (
        <Loader />
      ) : (
        <div style={{height: '100%'}}>
          <OrgChartComponent
            data={mainData}
            isHorizontal={true}
            chartType={ChartType.orgHierarchy}
            setSelectedYear={setSelectedYear}
            showLegend={true}
          />
        </div>
      )}
    </PageContent>
  );
};

export default OrgHierarchy;
